import styled from 'styled-components';
import { BLACK, GRAYSCALE_500, NEUTRAL_100, PALE_BLUE } from "../../styles/colors";
import { INTER } from "../../styles/fonts";

export const Container = styled.div<{ $hasSectionTitle?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 16px;
  border: 1px solid ${NEUTRAL_100};
  background-color: ${props => props.$hasSectionTitle ? 'transparent' : PALE_BLUE};
  border-radius: 12px;
`;

export const SectionTitle = styled.span`
  font-family: ${INTER.regular};
  color: ${BLACK};
`;

export const ParticlesContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MerchantTitle = styled.span`
  font-family: ${INTER.bold};
  color: ${BLACK};
`;

export const MerchantSubtitle = styled.span`
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_500};
`;
